import { Odds } from '@frontend/sports/odds/feature';
import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';

import { OddsChanged } from '../result/odds-changed';
import { IPickPreCheckError, PreCheckErrorMixin } from './pre-check-error';

export class OddsChangedPreCheckError extends PreCheckErrorMixin<typeof OddsChanged>(OddsChanged) implements IPickPreCheckError {
    constructor(pickId: string, currentOdds: Odds, expectedOdds: Odds, oddsFormat: OddsDisplayFormat) {
        super(pickId, currentOdds, expectedOdds, oddsFormat);
    }
}
